import { CREATE_RACK_URL, DELETE_RACK_URL, LIST_RACK_URL, RACK_LIST_DROPDOWN, RACK_SINGLE_DETAIL } from "../api";
import axiosInstance from "../axiosInstance";

export const createRack = (props) => onResponse => {
    try {
        axiosInstance.post(CREATE_RACK_URL, props?.values)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const listRack = (props) => onResponse => {
    try {
        let BASE_URL = LIST_RACK_URL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props?.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props?.order) {
            BASE_URL += 'order=' + props.order + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const getSingleRackDetail = (props) => onResponse => {
    try {
        let BASE_URL = RACK_SINGLE_DETAIL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.id) {
            BASE_URL += 'id=' + props.id + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const storageUnitDropdown = (props) => onResponse => {
    try {
        let BASE_URL = RACK_LIST_DROPDOWN + '?'
        if (props.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props.storage_system_id) {
            BASE_URL += 'storage_system_id=' + props.storage_system_id + '&'
        }
        if (props.sort_by) {
            BASE_URL += 'sort_by=' + props.sort_by + '&'
        } 
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });



    } catch (error) {

    }
}

export const deleteRack = (props) => onResponse => {
    try {


        axiosInstance.delete(DELETE_RACK_URL, { data: { id: props?.id } })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};